module.exports = __webpack_public_path__ + "img/twitter-white.4dfa3e55.svg";